import React from 'react';

function Notfound(props) {
    return (
        <div>
            page not found
        </div>
    );
}

export default Notfound;